module.exports = __webpack_public_path__ + "976f0e517c9741724a89efc988c0b8c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/haaretzSample.png
// module id = 3243
// module chunks = 0